import KanbanBoard from "./kanban-board";


export default KanbanBoard;